module.exports = __webpack_public_path__ + "static/media/muffler.79b3ee78.jpg";